<template>
    <div class="row offer-filter pad-top">
        <div class="col-12">
            <MultiSelect track-by="title" v-model="Storage.selectedCouriers" :options="Storage.couriers" :multiple="true"
                         :close-on-select="false" :clear-on-select="false" :hide-selected="false" :preserve-search="true"
                         :placeholder="$t('statistic.couriers')" label="title" :searchable="true" ref="multiselect"
                         :disabled="disabled">
                <template slot="option" scope="props">
                    <div class="option__desc">
                        <span class="option__title">
                            <span>{{ props.option.title }} <b v-if="Storage.developMode">({{ props.option.id }})</b></span>
                        </span>
                    </div>
                </template>
            </MultiSelect>
        </div>
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <button class="btn btn-info" @click="this.reset" :disabled="disabled"><i class="fa fa-trash"></i>
                        {{ $t('filters.reset') }}
                    </button>
                </div>
                <div class="col-6 action">
                    <button class="btn btn-success" @click="this.selectAll" :disabled="disabled"><i class="fa fa-reply-all"></i>
                        {{ $t('filters.select_all') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'

  export default {
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    name: 'CourierFilter',
    components: {
      MultiSelect
    },
    data () {
      return {
        Storage: Storage,
        vm: null
      }
    },
    mounted () {
      this.$root.$on('filters_reset_all', () => {
        this.reset()
      })
      this.$refs.multiselect.$on('select', function () {
        this.search = ''
      })
    },
    methods: {
      limitTextMessage (count) {
        return this.$root.$t('filters.more_pre') + count + this.$root.$t('filters.more_post')
      },
      selectAll () {
        Storage.selectedCouriers = Storage.couriers
        this.dispatchInputAction()
      },
      reset () {
        Storage.selectedCouriers = []
      }
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px; 
}
</style>



// WEBPACK FOOTER //
// CourierFilter.vue?2a09ff01